import h from '../../libs/jsx';

const BAR_SCORE_KEY = 'score';
const BAR_PRICE_SUM_KEY = 'price_sum_netto';
const BAR_PROCESS_TIME_KEY = 'process_time';
const BAR_INSTALLATION_STEPS_KEY = 'installation_steps';
const BAR_PAD_POSITIONS_KEY = 'plan_pad_positions_count';

const dynamicPropertiesForComparison = [
    { key: BAR_SCORE_KEY }
];

const propertiesForComparison = [
    { key: BAR_PRICE_SUM_KEY, allowRenderAsText: false },
    { key: BAR_PROCESS_TIME_KEY, allowRenderAsText: false },
    { key: BAR_INSTALLATION_STEPS_KEY, allowRenderAsText: false },
    { key: BAR_PAD_POSITIONS_KEY, allowRenderAsText: true },
];


export default class PackageBarsCalculator {

    barsData = {};

    constructor(options = {}) {
        ({ calculations: this.calculatedPropertiesByPackage = {} } = options);

        this.calculateBars();

        this.availableProperties = dynamicPropertiesForComparison.concat(propertiesForComparison);
    }

    calculateBars() {
        const extremes = {};
        for (const property of propertiesForComparison) {
            extremes[property.key] = this.findExtremes(property.key);
        }
        this.barsData = this.calculateBarsData(extremes);
        this.extendBarDataByScore(this.barsData);
    }

    createBarAllHTML(packageId) {
        const fullConfig = this.availableProperties.map(config => config.key).join(',');
        return this.createBarHTML(packageId, fullConfig, false, true);
    }

    createBarHTML(pacakgeId, expectedBarKeysList, renderLabels, renderCombatibleBarsAsText) {
        if (!this.barsData[pacakgeId] || !expectedBarKeysList) {
            return '';
        }

        const bars = this.barsData[pacakgeId];
        const expectedBarKeys = expectedBarKeysList.split(',');
        const expectedProperties = this.availableProperties.filter(property => (expectedBarKeys.includes(property.key) && !!bars.find(bar => bar.key === property.key)));
        const rows = expectedProperties.map((property) => { return { propertyConfig: property, bar: bars.find(bar => bar.key === property.key) } }).map((renderObject) => {
            const config = renderObject.propertyConfig;
            const bar = renderObject.bar;
            const renderLabel = renderLabels && !(config.allowRenderAsText && renderCombatibleBarsAsText);
            return (
                <div class={`bar ${bar.key} ${bar.best ? 'bar-best' : ''}`}>
                    <div class="bar-name">
                        {tp_trans.trans(`bar_${bar.key}`, `bar_${bar.key}`)}
                    </div>
                    <div class={renderLabels ? 'bar-label bar-label-left' : 'bar-label bar-label-left bar-label-empty'}>
                        {renderLabel ? (tp_trans.trans(`bar_max_${bar.key}`, `bar_max_${bar.key}`)) : (' ')}
                    </div>
                    {config.allowRenderAsText && renderCombatibleBarsAsText
                        ? (
                            <div class="bar-scale-number">
                                {bar.value}
                            </div>
                        ) : (
                            <div class="bar-scale">
                                <div class="bar-outer">
                                    <div class="bar-inner" style={{ width: `${bar.percentage}%` }}></div>
                                </div>
                            </div>
                        )
                    }
                    <div class="bar-label bar-label-right">
                        <span class="bar-label-tag">
                            {bar.best
                                ? tp_trans.trans(`bar_best_${bar.key}`, `bar_best_${bar.key}`)
                                : renderLabel ? (tp_trans.trans(`bar_min_${bar.key}`, `bar_min_${bar.key}`)) : (' ')}
                        </span>
                    </div>
                </div>
            )
        });
        return (
            <div class="product-comparison-bars">
                {rows}
            </div>
        );

    }

    calculateBarsData(extremes) {
        const barsData = {};
        for (const [property, minMax] of Object.entries(extremes)) {
            if (minMax.min === minMax.max) {
                continue;
            }

            for (const [packageId, calculation] of Object.entries(this.calculatedPropertiesByPackage)) {
                const percent = ((calculation[property] - minMax.min) / (minMax.max - minMax.min)) * 100;
                barsData[packageId] = barsData[packageId] ?? [];
                barsData[packageId].push({
                    value: calculation[property],
                    percentage: 100 - percent,
                    key: property,
                    best: calculation[property] === minMax.min,
                    worst: calculation[property] === minMax.max
                });
            }
        }

        return barsData;
    }

    extendBarDataByScore(barsData) {
        const scoreExtremes = {
            min: undefined,
            max: undefined
        };

        for (const [packageId, bars] of Object.entries(barsData)) {
            const totalPercentage = bars.reduce((accumulator, currentValue) => accumulator + currentValue.percentage, 0);
            const averagePercentage = totalPercentage / bars.length;
            bars.push({
                percentage: averagePercentage,
                key: BAR_SCORE_KEY,
                best: false,
                worst: false
            });
            scoreExtremes.min = scoreExtremes.min !== undefined ? Math.min(scoreExtremes.min, averagePercentage) : averagePercentage;
            scoreExtremes.max = scoreExtremes.max !== undefined ? Math.max(scoreExtremes.max, averagePercentage) : averagePercentage;
        }

        for (const [packageId, bars] of Object.entries(barsData)) {
            const scoreBar = bars.find(bar => bar.key === BAR_SCORE_KEY);
            if (scoreBar) {
                scoreBar.best = scoreBar.percentage === scoreExtremes.max;
                scoreBar.worst = scoreBar.percentage === scoreExtremes.min;
            }
        }

    }

    findExtremes(propertyName) {
        const extremes = {
            min: undefined,
            max: undefined
        };
        for (const [packageId, calculation] of Object.entries(this.calculatedPropertiesByPackage)) {
            extremes.min = extremes.min !== undefined ? Math.min(extremes.min, calculation[propertyName]) : calculation[propertyName];
            extremes.max = extremes.max !== undefined ? Math.max(extremes.max, calculation[propertyName]) : calculation[propertyName];
        }

        return extremes;
    }
}